// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rmc-drawer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.rmc-drawer-sidebar {
  z-index: 2;
  position: absolute;
  transition: transform 0.3s ease-out;
  will-change: transform;
  overflow-y: auto;
}
.rmc-drawer-draghandle {
  z-index: 1;
  position: absolute;
  background-color: rgba(50, 50, 50, 0.1);
}
.rmc-drawer-overlay {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.3);
}
.rmc-drawer-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  transition: left 0.3s ease-out, right 0.3s ease-out, top 0.3s ease-out, bottom 0.3s ease-out;
}
.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar,
.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar,
.rmc-drawer.rmc-drawer-left .rmc-drawer-draghandle,
.rmc-drawer.rmc-drawer-right .rmc-drawer-draghandle {
  top: 0;
  bottom: 0;
}
.rmc-drawer.rmc-drawer-left .rmc-drawer-draghandle,
.rmc-drawer.rmc-drawer-right .rmc-drawer-draghandle {
  width: 20px;
  height: 100%;
}
.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar,
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar,
.rmc-drawer.rmc-drawer-top .rmc-drawer-draghandle,
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-draghandle {
  left: 0;
  right: 0;
}
.rmc-drawer.rmc-drawer-top .rmc-drawer-draghandle,
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-draghandle {
  width: 100%;
  height: 20px;
}
.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {
  left: 0;
  transform: translateX(-100%);
}
.rmc-drawer-open.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
}
.rmc-drawer.rmc-drawer-left .rmc-drawer-draghandle {
  left: 0;
}
.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {
  right: 0;
  transform: translateX(100%);
}
.rmc-drawer-open.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {
  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.15);
}
.rmc-drawer.rmc-drawer-right .rmc-drawer-draghandle {
  right: 0;
}
.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {
  top: 0;
  transform: translateY(-100%);
}
.rmc-drawer-open.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
}
.rmc-drawer.rmc-drawer-top .rmc-drawer-draghandle {
  top: 0;
}
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {
  bottom: 0;
  transform: translateY(100%);
}
.rmc-drawer-open.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {
  box-shadow: 2px -2px 4px rgba(0, 0, 0, 0.15);
}
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-draghandle {
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/rmc-drawer/assets/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,4FAA4F;AAC9F;AACA;;;;EAIE,MAAM;EACN,SAAS;AACX;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;;;EAIE,OAAO;EACP,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,OAAO;EACP,4BAA4B;AAC9B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,QAAQ;AACV;AACA;EACE,MAAM;EACN,4BAA4B;AAC9B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,SAAS;AACX","sourcesContent":[".rmc-drawer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n.rmc-drawer-sidebar {\n  z-index: 2;\n  position: absolute;\n  transition: transform 0.3s ease-out;\n  will-change: transform;\n  overflow-y: auto;\n}\n.rmc-drawer-draghandle {\n  z-index: 1;\n  position: absolute;\n  background-color: rgba(50, 50, 50, 0.1);\n}\n.rmc-drawer-overlay {\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease-out;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.rmc-drawer-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  transition: left 0.3s ease-out, right 0.3s ease-out, top 0.3s ease-out, bottom 0.3s ease-out;\n}\n.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar,\n.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar,\n.rmc-drawer.rmc-drawer-left .rmc-drawer-draghandle,\n.rmc-drawer.rmc-drawer-right .rmc-drawer-draghandle {\n  top: 0;\n  bottom: 0;\n}\n.rmc-drawer.rmc-drawer-left .rmc-drawer-draghandle,\n.rmc-drawer.rmc-drawer-right .rmc-drawer-draghandle {\n  width: 20px;\n  height: 100%;\n}\n.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar,\n.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar,\n.rmc-drawer.rmc-drawer-top .rmc-drawer-draghandle,\n.rmc-drawer.rmc-drawer-bottom .rmc-drawer-draghandle {\n  left: 0;\n  right: 0;\n}\n.rmc-drawer.rmc-drawer-top .rmc-drawer-draghandle,\n.rmc-drawer.rmc-drawer-bottom .rmc-drawer-draghandle {\n  width: 100%;\n  height: 20px;\n}\n.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {\n  left: 0;\n  transform: translateX(-100%);\n}\n.rmc-drawer-open.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);\n}\n.rmc-drawer.rmc-drawer-left .rmc-drawer-draghandle {\n  left: 0;\n}\n.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {\n  right: 0;\n  transform: translateX(100%);\n}\n.rmc-drawer-open.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {\n  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.15);\n}\n.rmc-drawer.rmc-drawer-right .rmc-drawer-draghandle {\n  right: 0;\n}\n.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {\n  top: 0;\n  transform: translateY(-100%);\n}\n.rmc-drawer-open.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);\n}\n.rmc-drawer.rmc-drawer-top .rmc-drawer-draghandle {\n  top: 0;\n}\n.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {\n  bottom: 0;\n  transform: translateY(100%);\n}\n.rmc-drawer-open.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {\n  box-shadow: 2px -2px 4px rgba(0, 0, 0, 0.15);\n}\n.rmc-drawer.rmc-drawer-bottom .rmc-drawer-draghandle {\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
